export default __webpack_public_path__ + "static/media/Helm of Erlik.59d299c2.jpg";